import { Col, Text } from 'components';
import { theme } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ProgressBadge = ({ status, progress, gameStatus, sport }) => {
  const [text, setText] = useState(''),
    { t } = useTranslation();

  useEffect(() => {
    updateText();
  }, [progress, gameStatus, status]);

  function updateText() {
    switch (true) {
      case gameStatus === 'HT':
        return setText(t('games.ht'));
      case status === 'finished':
        return setText(t('games.ft'));
      case sport === 'basketball':
        return setText(gameStatus);
      default:
        return setText(`${progress}'`);
    }
  }

  if (!text || !['live', 'finished'].includes(status)) return null;

  return (
    <Col
      centerAll
      wid="40px"
      ht="22px"
      bg={status === 'finished' ? theme.SECONDARY : theme.GREEN}
      noFlex
    >
      <Text med>{text}</Text>
    </Col>
  );
};

export default ProgressBadge;
